module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/download-553ba6c7cbbe2d6a7eab1898ca4d3608.png";